<template>
  <div class="quotationEditor">
    <div class="quotationEditor__header">
      <!-- <div class="back" @click.stop="goQuotationList()">
        <span class="back__icon strong"><i class="adx-ic_arrow_left"></i></span>
        <span class="back__all subhead color-pink">All Quotation</span>
      </div> -->
      <div class="title"><h1 class="medium-title">Campaign Quotation</h1></div>
      <div class="title-2"><span class="subhead">Create detail information for quotation</span></div>
    </div>
    <div class="quotationEditor__body" v-if="!isLoadingForm">
      <div class="quotationEditor__body__left">
          <div class="quotationEditor__body__left__container">
            <h1 class="subhead title"> Campaign Quotation Name</h1>  
            <div class="quotationEditor__body__left__container__item">
              <adx-input :label="`Name`" :value.sync="model.quotationName" :inputId="`campaign_name`"
                :error.sync="vuelidateOptions.quotationName.error" :ref="vuelidateOptions.quotationName.ref"/>
            </div>
          </div>
          <div v-if="isLoadingClient">
            <adx-loading/>
          </div>
          <div v-else class="quotationEditor__body__left__container">
            <h1 class="subhead title"> Client Informations</h1>
            <div class="quotationEditor__body__left__container__item">
              <adx-single-search-dropdown :label="'Client Profile'" :optionsParam="clientProfileList" 
               @selected="changeClientProfile" :value.sync="model.clientProfile" 
               :error.sync="vuelidateOptions.clientProfile.error" :loading="isClientLoading" :ref="vuelidateOptions.clientProfile.ref"/>
            </div>
            <div class="quotationEditor__body__left__container__loading" v-if="loadingDetailClient">
              <adx-loading/>
            </div>
            <div  v-else>
              <div class="quotationEditor__body__left__container__item">
                <adx-input :label="`Company Name`" :value.sync="clientProfile.companyName" :inputId="`company_name`"/>
                <adx-input :label="`Brand`" :value.sync="clientProfile.brand" :inputId="`brand_name`"/>
              </div>
              <div class="quotationEditor__body__left__container__item">
                <adx-input :label="`Contact Person`" :value.sync="clientProfile.contactPerson" :inputId="`contact_name`"/>
                <adx-input :label="`Email Address`" :value.sync="clientProfile.emailAdress" :inputId="`email_name`"/>
              </div>
              <div class="quotationEditor__body__left__container__item">
                <adx-input class="single-input" :label="`Phone Number`" :value.sync="clientProfile.phoneNumber" :inputId="`phone_number`"/>
              </div>
            </div>
              <div class="quotationEditor__body__left__container__item">
                <adx-textarea :label="`Quotation Note (Optional)`" :value.sync="model.note"/>
              </div>
              <div class="quotationEditor__body__left__container__button">
                <button class="btn-regular secondary update" v-if="this.clientProfileId" @click="createOrUpdateClient('update')">
                  Update existing client
                </button>
                <button class="btn-regular primary create-new" @click="checkBrand('create')">
                  Save as New Client
                <!-- <adx-loading-secondary-white class="circle-loading" v-if="isLoadingUpdate" /> -->
                </button>
            </div>
          </div>
          <div class="quotationEditor__body__left__container">
            <h1 class="subhead title"> Internal Message Here ( Optional ) </h1>
            <div class="quotationEditor__body__left__container__item">
              <adx-textarea :label="'Leave a message'" :value.sync="model.message"/>
            </div>
          </div>
      </div>
      <div class="quotationEditor__body__right">
        <div class="quotationEditor__body__right__container">
          <h1 class="subhead title">Campaign Summary</h1>
          <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> Selected Channel </span>
            <span class="subhead"> {{this.model.totalCampaign}} </span>
          </div>
          <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> Total Item </span>
            <span class="subhead"> {{this.model.totalItem}} </span>
          </div>
          <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> Campaign Start </span>
            <span class="subhead"> {{this.displayDate(this.model.start)}} </span>
          </div>
          <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> Campaign End </span>
            <span class="subhead"> {{this.displayDate(this.model.end)}}</span>
          </div>
        </div>
        <div class="quotationEditor__body__right__container">
          <!-- <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> Subtotal Price </span>
            <span class="subhead color-pink"> {{model.totalPrice | formatMoney}}</span>
          </div> -->
          <!-- <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> Service Fee </span>
            <span class="subhead color-pink"> {{model.serviceFee ? (model.serviceFee | formatMoney) : '-'}}</span>
          </div> -->
          <!-- <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> PPN 10% </span>
            <span class="subhead color-pink"> {{ ppn | formatMoney}}</span>
          </div> -->
          <div class="quotationEditor__body__right__container__item">
            <span class="subhead"> Total Price </span>
            <span class="price color-pink"> {{ totalPriceFinal | formatMoney}}</span>
          </div>
        </div>
        <div class="quotationEditor__body__right__button__top">
          <button class="btn-regular primary" :class="[isLoadingUpdate? 'disabled': '']" @click="validateQuotation" :disabled="isLoadingUpdate">Continue
            <adx-loading-secondary-white v-if="isLoadingUpdate"/>
          </button>
        </div>
      </div>
    </div>
    <adx-loading v-else/>
     <adx-modal hideClose="true" v-if="isQuotationCreated" type="small">
      <div slot="content" class="quotationEditor__modal-2">
        <div class="quotationEditor__modal-2__top">
          <img class="icon-img" :src="iconImg" alt="">
          <h1 class="title bold medium-title">Quotation Created</h1>
        </div>
        <div class="quotationEditor__modal-2__center subhead">
            Awesome team! your quotation has been created.
        </div>
        <div class="quotationEditor__modal-2__bottom">
          <button class="btn-block primary" @click="goQuotationList()">View My Qoutation</button>
        </div>
      </div>
    </adx-modal>
    <adx-modal
    v-if="isShowModalContinue"
    @modal-close="toggleModalRemove"
    title="Continue?"
    type="small">
    <div slot="content" class="quotationEditor__modal-2">
      <div class="quotationEditor__modal-2__top">
        <span class="sub-title subhead">Brand name has already saved on our list</span>
      </div>
      <div class="quotationEditor__modal-2__bottom">
        <button class="btn-block primary continue-btn" @click="createOrUpdateClient('create')">Continue</button>
        <button class="btn-block secondary" @click="toggleModalRemove">Cancel</button>
      </div>
    </div>
  </adx-modal>
  </div>
</template>

<script>
import LoadingSecondaryWhite from '@/components/Loading/Secondary-white'
import { mapListFilter } from '@/lib/transformer'
import api from "@/api"
import lib from "@/lib/util"
import { apiV2 } from "@/api/urls"
import { helpers } from "@/lib/validation/"
import { mapGetters } from "vuex"
import { restEdge } from "@/api/edgeUrls"
import { globalMixins } from "@/lib/mixins/globalMixins";
import { ACheckbox, AInput, ATextArea, ASelectDropdown, AModal, ALoadingSecondary, AListDropdown, ATable,
        ALoadingSecondaryWhite, ASingleSearchDropdown, ALoadingPrimary, AEmptySelection, APagination, ADiscussions} from "ui-kit-v1"
import { required, minLength, email, alphaNum } from 'vuelidate/lib/validators'

const phone_validation = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[+]*(\([+0-9\s]*\)[\-\s]*)*[\-0-9\s]*$/.test(value)
}

export default {
  name: "adx-campaign-bus",
  components: {
    "adx-loading": ALoadingPrimary,
    "adx-loading-2": ALoadingSecondary,
    "adx-loading-white": ALoadingSecondaryWhite,
    'adx-loading-secondary-white': LoadingSecondaryWhite,
    "adx-pagination": APagination,
    "adx-dropdown-sort": ASelectDropdown,
    "adx-dropdown-list": AListDropdown,
    "adx-textarea": ATextArea,
    "adx-table": ATable,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-input": AInput,
    "adx-select-dropdown": ASelectDropdown,
    "adx-modal": AModal,
    "adx-discussions": ADiscussions,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      id: null,
      isLoadingForm: false,
      isLoadingUpdate: false,
      isLoadingClient: false,
      isQuotationCreated: false,
      isShowModalContinue: false,
      loadingDetailClient: false,
      isClientLoading: false,
      iconImg: "/img/icon-checklist.png",
      clientProfileList: [],
      brandList: [],
      model: {
        quotationName: null,
        clientProfile: '',
        note: null,
        status: null,
        totalPrice: null,
        serviceFee: null,
        owner: null,
        start: null,
        end: null,
        totalCampaign: null,
        totalItem: null,
        message: null,
        campaign_list: [],
        selectedCampaignIds: [],
      },
      clientProfileId : null,
      clientProfile: {
        // selected: '',
        companyName: null,
        brand: null,
        contactPerson: null,
        emailAdress: null,
        phoneNumber: null,
      },
      vuelidateOptions: {
        quotationName: {
          field: 'quotation name',
          error: null,
          ref: 'quotationName'
        },
        clientProfile: {
          field: 'client profile ',
          error: null,
          ref: 'clientProfile'
        },
        // companyName: {
        //   field: 'company name',
        //   error: null,
        //   ref: 'companyName'
        // },
        // brand: {
        //   error: null,
        //   ref: 'brand'
        // },
        // contactPerson: {
        //   field: 'contact person',
        //   error: null,
        //   ref: 'contactPerson'
        // },
        // emailAdress: {
        //   field: 'email address',
        //   error: null,
        //   ref: 'emailAdress'
        // },
        // phoneNumber: {
        //   message: 'Please use valid phone number format',
        //   field: 'phone number',
        //   error: null,
        //   ref: 'phoneNumber'
        // },
      }
    };
  },
  validations: {
    model: {
      quotationName: { required, minLength: minLength(3) },
      clientProfile: {required}
      // companyName: { required },
      // brand: { required },
      // contactPerson: { required, minLength: minLength(3) }, 
      // emailAdress: { required, email},
      // phoneNumber: { required, phone_validation},
    },
  },
  computed: {
    ...mapGetters({
      token: "token",
      isSuperuser: "isSuperuser"
    }),
    ppn(){
      return 0.1 * (parseInt(this.model.totalPrice) + parseInt(this.model.serviceFee))
    },
    totalPriceFinal(){
      return this.model.totalPrice + this.model.serviceFee + this.ppn
    }
  },
  watch: {

  },
  apollo: {

  },
  beforeCreate() {

  },
  async created() {
  
  },
  async beforeMount() {

  },
  async mounted() {
    let query = this.$route.query;
    this.id = this.$route.params.id
    this.getDetailQuotation()
  },

  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {
    
  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getDetailQuotation(){
      this.isLoadingForm = true
      const {data, status} = await api.get(restEdge.getOneQuotation(this.id), { needToken: true, useRestEdge: true });
      if (status == 200) {
        this.mapData(data)
        this.getClientProfile(data)
      } else {
        this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
      }
      this.isLoadingForm = false
    },
    mapData(data){
      this.model.quotationName = data.name
      this.model.note = data.note
      this.model.status = data.status
      this.model.totalPrice = data.total_price
      this.model.owner = data.owner
      this.model.serviceFee = data.total_service_fee ? data.total_service_fee : 0
      this.model.start = data.start
      this.model.end = data.end
      this.model.totalCampaign = data.number_of_campaigns
      this.model.campaign_list = data.campaign_list
      this.clientProfileId = data.client_profile

      //get total item
      let totalItem = []
      data.campaign_list.map( campaign =>{
        campaign.campaign_medias.map( media =>{
          media.line_item_list.map(line_item =>{
            totalItem.push(line_item)
          })
        })
      })
      this.model.totalItem = totalItem.length

      //mapping item campaign 
      this.model.campaign_list.map( el =>{
        this.model.selectedCampaignIds.push(el.id)
      })
    },
    async getClientProfile(response){
      this.isClientLoading = true
      const {data, status} = await api.get(restEdge.getClientProfile, { 
        needToken: true, 
        useRestEdge: true 
      });

      if (status == 200) {
        this.clientProfileList = mapListFilter({obj: data, id:`id`, value:`id`, label: `name`})
        this.brandList = data.map(data => data.brand)
        this.model.clientProfile = this.clientProfileList.filter( x => x.id == this.clientProfileId).pop()
        if(this.clientProfileId){
          this.getDetailClientProfile()
        }
      }else {
        this.dangerAlert()
      }
      this.isClientLoading = false
    },
    async getDetailClientProfile(){
      this.loadingDetailClient = true
      const {data, status} = await api.get(restEdge.getOneClientProfile(this.clientProfileId), { 
        needToken: true, 
        useRestEdge: true 
      });

      this.clientProfile.companyName = data.company_name ? data.company_name : '-',
      this.clientProfile.brand = data.brand ? data.brand : '-',
      this.clientProfile.contactPerson = data.contact_person ? data.contact_person : '-',
      this.clientProfile.emailAdress = data.email ? data.email : '-',
      this.clientProfile.phoneNumber = data.phone_number ? data.phone_number : '-'
      this.loadingDetailClient = false
    },
    async createOrUpdateClient(param){
      this.isLoadingClient = true
      let body = {}
      body = {
        name : "name",
        company_name : this.clientProfile.companyName,
        contact_person : this.clientProfile.contactPerson,
        phone_number : this.clientProfile.phoneNumber,
        brand : this.clientProfile.brand,
        email : this.clientProfile.emailAdress
      }

      if (param == 'create'){
        const {data, status} = await api.post(restEdge.createClientProfile, body, { 
          needToken: true, 
          useRestEdge: true 
        });

        if (status == 200) {
          this.showNotificationAlert('Success', ' successfully create new client profile !', 'success')
          this.isLoadingClient = false
          this.getClientProfile()
          this.clientProfile.companyName = ''
          this.clientProfile.brand = ''
          this.clientProfile.contactPerson = ''
          this.clientProfile.emailAdress = ''
          this.clientProfile.phoneNumber = ''
        } else{
          this.dangerAllert()
        }
        this.isShowModalContinue = false
      } else {
        const {data, status} = await api.patch(restEdge.editClientProfile(this.clientProfileId), body, { 
          needToken: true, 
          useRestEdge: true 
        });

        if (status == 200) {
          this.showNotificationAlert('Success', ' successfully updated client profile !', 'success')
          this.isLoadingClient = false
          this.getDetailClientProfile()
        } else {
          this.dangerAlert()
        }
      }
      //this.toggleModalRemove()
    },
    changeClientProfile(params){
      this.clientProfileId = params.item.id
      this.getDetailClientProfile()
    },
    dangerAlert(){
      this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
    },
    validateQuotation(){
      this.isLoadingUpdate = true
      // this.$v.$touch()
      // if (this.$v.model.$invalid) {
      //   this.vuelidateHelper(this.vuelidateOptions)
      //   this.isLoadingUpdate = false
      // } else {
        this.updateQuotation()
      // }
    }, 
    async updateQuotation(){
      let discussion = null
      if(this.model.message) {
        discussion = {
          message: this.model.message,
          quotation: this.id,
          user: this.model.owner
        }
      }

      let body = { 
          name: this.model.quotationName,
          status: this.model.status,
          total_price: this.model.totalPrice,
          campaigns_id: this.model.selectedCampaignIds,
          client_profile: this.clientProfileId,
          owner: this.model.owner,
          note:  this.model.note,
          discussion_item: discussion
        }

      const {data, status} = await api.patch(restEdge.editQuotation(this.id), body, { needToken: true, useRestEdge: true })
      if (status == 200){
        this.showNotificationAlert('Success', 'Quotation successfully update!', 'success')
        this.isQuotationCreated = true
        // this.goQuotationList()
      } else{
        this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
      }
      this.isLoadingUpdate = false
    },
    goQuotationList() {
       this.$router.push({ name: 'quotationlist'});
    },
    toggleModalRemove(){
      this.isShowModalContinue = !this.isShowModalContinue
    },
    checkBrand(param){
      if (this.brandList.includes(this.clientProfile.brand)){
        this.isShowModalContinue = true
      }else{
        this.createOrUpdateClient('create')
      }
    },
    displayDate(date){
      return date? `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', new Date(date))}`: '-'
    },
    vuelidateHelper(vuelidateOptions){
      const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, vuelidateOptions, this.$refs)

      if (collection) {
        vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
      } else {
        vuelidateOptions[key].error = message
      }
      if (typeof element[0] == "undefined") {
        this.$nextTick(function() {
          element.scrollIntoView();
        });
      } else {
        this.$nextTick(function() {
          if (element[0].hasOwnProperty("$el")) {
            element[0].$el.scrollIntoView();
          } else {
            element[0].scrollIntoView();
          }
        });
      }
      this.saveLoading = false
    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
